import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const GetMultipartVideoUploadUrlsApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    body: z.object({
        filename: z.string(),
        parts: z.coerce.number().min(1).max(10_000), // as of 2025-09-15
        requiresStitching: z.coerce.boolean().optional(),
        startTime: z.string().datetime(),
        uploadId: z.string(),
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema.pick({ requestActor: true }),
    response: z.object({
        multipartVideoUploadUrls: z
            .object({
            signedUrl: z.string(),
            partNumber: z.number(),
        })
            .array(),
    }),
};
export const GetMultipartVideoUploadUrlsRequestSchema = GetMultipartVideoUploadUrlsApiSchema.params
    .merge(GetMultipartVideoUploadUrlsApiSchema.headers)
    .merge(GetMultipartVideoUploadUrlsApiSchema.body);
export const GetMultipartVideoUploadUrlsResponseSchema = GetMultipartVideoUploadUrlsApiSchema.response;
